<template>
  <div class="filters__body">
    <ul uk-accordion="multiple: true">
      <li v-if="hideFilters === false" class="uk-position-relative uk-open">
        <a class="uk-accordion-title uk-disabled">{{ $t('frontend-mtg.filters.active_filters') }}</a>
        <div v-for="(filter, key) in filters" class="uk-accordion-content"
             v-if="key !== 'product_sector_id' && key !== 'product_category_id' && filter.length > 0" >
          <p class="filters__active-label">{{ $t('frontend-mtg.filters.' + key) }}:</p>
          <ul uk-nav class="filters__active">
            <li v-for="filterItem in filter" @click="removeFilter(key, filterItem)">
              <a class="filters__active-item">{{ getFilterTitleById(key, filterItem) }}</a>
            </li>
          </ul>
        </div>
        <div @click="removeAllFilters()" class="filters__nav-cta uk-margin-medium-bottom">{{ $t('frontend-mtg.filters.reset_all') }}</div>
      </li>
      <li class="uk-position-relative uk-open">
        <a class="uk-accordion-title uk-disabled" :title="$t('frontend-mtg.filters.sectors')">{{ $t('frontend-mtg.filters.sectors') }}</a>
        <div class="uk-accordion-content">
          <ul uk-nav class="filters__menu">
            <li v-for="sector in sectors">
              <a :href="sector.url">{{ sector.name }}</a>
            </li>
          </ul>
        </div>
      </li>
      <li v-if="hideFilters === false" v-for="(availableFilter, key) in availableFilters" class="uk-position-relative uk-open">
        <p v-if="count === 0 && count++" class="uk-accordion-label uk-margin-top uk-margin-remove-bottom">
          {{ $t('frontend-mtg.filters.filter_by') }}
        </p>
        <a class="uk-accordion-title" href="#" :title="$t('frontend-mtg.filters.' + key)">
          {{ $t('frontend-mtg.filters.' + key) }}
        </a>
        <div class="uk-accordion-content">
          <ul uk-nav class="filters__nav">
            <li v-for="filter in availableFilter">
              <label class="checkbox__label">
                <input class="uk-checkbox filter-checkbox"
                       :checked="filters[filter.type] && filters[filter.type].includes(filter.id)"
                       @change="toggleFilter(filter.type, filter.id)" type="checkbox"
                       :filterType="filter.type" :filterId="filter.id"
                >
                <span>{{ filter.title }}</span>
              </label>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    sectors: {
      type: [Array, Object],
      required: true,
    },
    hideFilters: {
      type: Boolean,
      required: true,
    },
    availableFilters: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      count: 0,
    }
  },
  computed: {
    filters(){
      return this.$store.state.grid.filters;
    }
  },
  methods: {
    toggleFilter(type, id) {
      if (!type || !id) {
        return;
      }
      let tmpFilter = this.filters[type] || [];
      if (! Object.values(tmpFilter).includes(id)) {
        this.$store.commit('grid/addFilter', {
          column: type,
          value: tmpFilter.concat([id])
        });
      } else {
        this.removeFilter(type, id)
      }
    },
    removeAllFilters(){
      let self = this;
      Object.entries(this.$store.state.grid.filters).forEach(function (item){
        if(item[0] !== 'product_sector_id' && item[0] !== 'product_category_id' ){
          Object.values(item[1]).forEach(function (id){
            self.removeFilter(item[0], id)
          })
        }
      })
    },
    removeFilter(type, id){
      this.$store.commit('grid/removeFilter', {
        column: type,
        value: id
      });
    },
    getFilterTitleById(type, id){
      let results = this.availableFilters[type].filter(function (item) {
        return item.id === id;
      });
      return results[0].title;
    }
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/CatalogFilters.vue